import { UnitCertificatesReducerStateType } from '@modules/unit-certificate/unit-certificates-section/types';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  offset: 0,
  limit: 25,
  order: 'desc',
  sortBy: 'username',
  totalCount: 0,
  menuItemClicked: '',
  isApprovedState: null
} as UnitCertificatesReducerStateType;

export const unitCertificatesStateReducerSlice = createSlice({
  name: 'unitCertificatesStateReducer',
  initialState,
  reducers: {
    resetUnitCertificatesStateReducerValues: () => initialState,
    updateUnitCertificatesStateReducerValues: (state, { payload }) => ({
      ...state,
      ...payload
    })
  }
});

export const {
  resetUnitCertificatesStateReducerValues,
  updateUnitCertificatesStateReducerValues
} = unitCertificatesStateReducerSlice.actions;

export default unitCertificatesStateReducerSlice.reducer;
